<script>
import { mapGetters } from 'vuex'
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import appButton from '@/components/common/app-button'
import appDialog from '@/components/common/app-dialog'
import appClose from '@/components/common/app-close'
import { smartCatalog } from '@/API'

export default {
  name: 'app-smart-catalog-item',
  components: { appButton, appDialog, appClose, VueTelInput },
  props: {
    leadName: String,
    userId: Number,
    leadId: Number,
    presUrl: String,
    pId: String,
    formatFeedback: String,
    isMobileVersion: Boolean
  },

  data() {
    return {
      isShowFeedbackDialog: false,
      isSuccessSendFeedback: false,
      isErrorSendFeedback: false,
      isSendFeedback: false,
      dialogForm: {
        name: {
          value: '',
          isError: false
        },
        phone: {
          value: '',
          isError: false
        },
        comment: {
          value: '',
          isError: false
        }
      }
    }
  },


  methods: {
    checkPhoneValidate({ valid }) {
      this.dialogForm.phone.isError = !valid
    },
    objectClickHandler(e) {
      if (!this.isPresFormat) {
        e.preventDefault()
      }
    },

    closeFeedbackDialog() {
      this.isShowFeedbackDialog = false
    },

    checkDialogForm() {
      let isValid = true
      if (!this.dialogForm.phone.value || this.dialogForm.phone.isError) {
        isValid = false
        this.dialogForm.phone.isError = true
      } else {
        this.dialogForm.phone.isError = false
      }

      if (!this.dialogForm.name.value) {
        isValid = false
        this.dialogForm.name.isError = true
      } else {
        this.dialogForm.name.isError = false
      }
      return isValid
    },

    async sendFeedback() {
      if (this.checkDialogForm()) {
        try {
          const res = await smartCatalog.sendFeedback({
            domain: this.$route.params.domain,
            name: this.dialogForm.name.value,
            _id: this.$route.params._id,
            phone: this.dialogForm.phone.valu
              ?.split('')
              .filter(s => !['+', ' '].includes(s))
              .join(''),
            comment: this.dialogForm.comment.value,
            leadName: this.leadName
          })
          if (res.status === 200) {
            this.isSendFeedback = true
            this.isSuccessSendFeedback = true
          }
        } catch (e) {
          console.log(e)
          console.log(e.response)
          this.isSendFeedback = true
          this.isErrorSendFeedback = true
        }

      }
    },

    openFeedbackDialog() {
      this.isSuccessSendFeedback = false
      this.isErrorSendFeedback = false
      this.isSendFeedback = false
      this.isShowFeedbackDialog = true

      this.dialogForm.name.value = ''
      this.dialogForm.phone.value = ''
      this.dialogForm.comment.value = ''
    },

    inputHandler(input) {
      const currentInput = this.dialogForm[input]
      if (currentInput.value) {
        currentInput.isError = false
      }
    }
  },

  computed: {
    isFormPresFormat() {
      return this.formatFeedback === 'formPres'
    },
    isPresFormat() {
      return this.formatFeedback === 'pres' || this.isFormPresFormat
    },
    isFormFormat() {
      return this.formatFeedback === 'form' || this.isFormPresFormat
    },
    ...mapGetters({
      getPresentationConstantTranslationByKey: 'account/getPresentationConstantTranslationByKey',
    }),
    presentationLink() {
      const pIdParam = this.pId ? `&pId=${this.pId}` : ''
      return `${this.presUrl}${this.$route.params.domain}/${this.userId}?ids=${this.leadId}${pIdParam}`
    },
  }
}
</script>

<template>
  <a
    target="_blank"
    @click="objectClickHandler"
    :href="presentationLink"
  >
    <div
      class="catalog-item relative grid grid-rows-card grid-cols-1 border-solid border border-light-gray-300 transition duration-200 hover:shadow-boxShadowHoverCard"
    >
      <div>
        <slot name="images_slider"></slot>
      </div>
      <div>
        <slot name="content"></slot>
      </div>
      <div
        class="flex mb-5"
        :class="{
          'catalog-item__actions': !isMobileVersion,
          'catalog-item__actions--active': !isMobileVersion,
          'justify-center': isMobileVersion,
          'justify-end': !isMobileVersion,
          'mr-4': !isMobileVersion,
        }"
        v-if="isFormFormat"
      >
        <app-button
          :class="{
            'signUpForViewing': !isMobileVersion,
          }"
          :name="getPresentationConstantTranslationByKey('sign-up-for-viewing')"
          @btnClick.prevent="openFeedbackDialog"
        />
      </div>
    </div>
  </a>
  <app-dialog
    v-if="isShowFeedbackDialog"
    @click.prevent=""
    @close="closeFeedbackDialog"
    max-width="500px"
  >
    <template #header>
      <div class="flex items-center justify-between">
        <h3 class="text-2xl">
          {{ getPresentationConstantTranslationByKey('application') }}
        </h3>
        <div 
          class="w-5 h-5 cursor-pointer hover:text-blue-500 hover:fill-current hover:text-headerHover"
          @click="closeFeedbackDialog"
        >
          <appClose />
        </div>
      </div>
    </template>
    <template #body>
      <div
        v-if="isSendFeedback"
      >
        <div
          class="text-base"
          v-if="isSuccessSendFeedback"
        >
          {{ getPresentationConstantTranslationByKey('application-has-been-sent') }}.
        </div>
        <div
          class="text-base"
          v-if="isErrorSendFeedback"
        >
          {{ getPresentationConstantTranslationByKey('something-went-wrong') }}.
        </div>
      </div>
      <div
        class="mt-1"
        v-else
      >
        <div
          class="relative h-10 input-component mb-5"
          :class="{
            empty: !dialogForm.name.value
          }"
        >
          <input
            id="name"
            type="text"
            name="name"
            class="input-component-item input-component__input h-full w-full px-2 transition-all border-blue rounded-sm"
            :class="{
              'border-gray-300': !dialogForm.name.isError,
              'border-red-500': dialogForm.name.isError
            }"
            v-model.trim="dialogForm.name.value"
            @input="inputHandler('name')"
          />
          <label
            for="name"
            class="input-component__label absolute left-2 transition-all bg-white px-1"
            :class="{
              'invalid': dialogForm.name.isError
            }"
          >
            {{ getPresentationConstantTranslationByKey('application-name') }}
          </label>
        </div>

        <div
          class="relative h-10 mb-5"
          :class="{
            empty: !dialogForm.phone.value
          }"
        >
          <vue-tel-input
            defaultCountry="RU"
            mode="international"
            :inputOptions="{
              id: 'phone',
              showDialCode: true,
              placeholder: 'Введите номер телефона',
              required: true,
            }"
            @validate="checkPhoneValidate"
            v-model="dialogForm.phone.value"
          />
          <label
            for="phone"
            class="input-component__label absolute left-2 transition-all bg-white px-1"
            :class="{
              'invalid': dialogForm.phone.isError
            }"
          >
            {{ getPresentationConstantTranslationByKey('application-phone') }}
          </label>
        </div>

        <div
          class="relative h-20 input-component mb-5"
          :class="{
            empty: !dialogForm.comment.value
          }"
        >
          <textarea
            id="comment"
            name="name"
            class="input-component-item input-component__textarea h-full w-full resize-none border-gray-300 px-2 pt-2 transition-all border-blue rounded-sm"
            v-model.trim="dialogForm.comment.value"
          />
          <label
            for="comment"
            class="input-component__label absolute left-2 transition-all bg-white px-1"
          >
            {{ getPresentationConstantTranslationByKey('application-comment') }}
          </label>
        </div>
      </div>
    </template>
    <template #footer>
      <div
        class="flex justify-end"
        v-if="!isSendFeedback"
      >
        <div>
          <app-button
            :name="getPresentationConstantTranslationByKey('sign-up-for-viewing')"
            @btnClick="sendFeedback"
          />
        </div>
      </div>
    </template>
  </app-dialog>
</template>

<style scoped>
.input-component__label {
  top: 0;
  transform: translateY(-50%);
  font-size: 11px;
  color: rgba(37, 99, 235, 1);
}

.empty .input-component__input:not(:focus) + .input-component__label {
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
}

.empty .input-component__textarea:not(:focus) + .input-component__label {
  top: 20px;
  font-size: 14px;
}

.input-component-item:not(:focus) + .input-component__label {
  color: rgba(70, 70, 70, 1);
}

.input-component-item {
  border-width: 1px;
}

.input-component-item:focus {
  outline: none;
  border-color: rgba(37, 99, 235, 1);
}

.input-component__label.invalid {
  color: #f43f5e !important;
}

.input-component__input:focus + .input-component__label.invalid {
  color: rgba(37, 99, 235, 1) !important;
}

.catalog-item__actions {
  display: flex;
  position: relative;
  left: 0;
  right: 0;
  bottom: 0;
}

</style>
